const getters = {
    membershipCart: state => state.membershipCart,
    membershipStatus: state => state.membershipStatus,
    membershipErrors: state => state.membershipErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
};

export default getters;
